/**
 * The four scored alert types shown on the analytics dashboard.
 *
 * Mirrors `backend/src/constants/callInsightAlertTypes.js` — the API returns
 * these exact keys in its trend payload, so the two must stay in step.
 *
 * Playbook adherence is deliberately not one of these: it is scored per session
 * rather than per detected item, so it is charted on its own.
 */
export const ALERT_TYPES = ['objection', 'faq', 'landmine', 'competitor'] as const;

export type AlertType = (typeof ALERT_TYPES)[number];

export const ALERT_TYPE_LABELS: Record<AlertType, string> = {
  objection: 'Objections',
  faq: 'FAQs',
  landmine: 'Landmines',
  competitor: 'Competitors',
};
